module.exports = __webpack_public_path__ + "images/graphic-mall-2@2x_42be258e9785aa37268727a8fc369cea.png";